import { DataTableHeaderV2Component, templateDataTableHeaderV2 } from './DataTableHeaderV2';
import styles from './DataTableHeaderV2.styles.scss';
export const chameleonDataTableHeaderV2 = DataTableHeaderV2Component.compose({
    baseName: 'data-table-header-v2',
    template: templateDataTableHeaderV2,
    styles,
});
